module.exports = __webpack_public_path__ + "static/media/88e104_a6943a6d4a75497686b2758331e31d80.564664d3.avif";